<script setup>
import { defineEmits, defineProps, ref, watch } from 'vue';

const props = defineProps({
	scaleName: { type: String, default: '' },
	defaultTitle: { type: String, default: '' },
	error: { type: String, default: '' },
	loading: { type: Boolean, default: false },
});

const emit = defineEmits(['close', 'confirm']);
const title = ref(props.defaultTitle);

watch(
	() => props.defaultTitle,
	(value) => {
		title.value = value || '';
	}
);

const confirm = () => {
	const value = title.value.trim();
	if (!value || props.loading) return;
	emit('confirm', value);
};
</script>

<template>
	<div class="fixed inset-0 z-50 flex items-center justify-center px-4">
		<div
			class="absolute inset-0 screening-title__mask"
			@click="emit('close')"
		></div>
		<div class="screening-title">
			<div class="screening-title__body">
				<div class="flex justify-center">
					<img
						src="@/assets/images/illustrations/edit.png"
						alt="Luca Education"
						title="Luca Education"
						height="60"
						width="60"
						class="mb-4"
					/>
				</div>
				<h2 class="screening-title__heading">Tạo mới</h2>
				<div class="screening-title__row">
					<div class="screening-title__label">Thang sàng lọc</div>
					<div class="screening-title__value">{{ scaleName }}</div>
				</div>
				<div class="screening-title__row screening-title__row--top">
					<div class="screening-title__label">Tiêu đề</div>
					<div class="flex-1">
						<input
							v-model="title"
							type="text"
							class="screening-title__input"
							@keyup.enter="confirm"
						/>
						<div v-if="error" class="screening-title__error">
							<svg
								width="16"
								height="16"
								viewBox="0 0 16 16"
								fill="none"
							>
								<circle
									cx="8"
									cy="8"
									r="7"
									stroke="#DB5A41"
									stroke-width="1.4"
								/>
								<path
									d="M8 4.5v4.2"
									stroke="#DB5A41"
									stroke-width="1.4"
									stroke-linecap="round"
								/>
								<circle
									cx="8"
									cy="11.2"
									r="0.8"
									fill="#DB5A41"
								/>
							</svg>
							<span>{{ error }}</span>
						</div>
					</div>
				</div>
			</div>
			<div
				class="_modal__footer px-12 py-6 bg-neutral-50 flex flex-nowrap items-center"
			>
				<button
					class="button-p text-center mr-3 bg-none shadow-none text-neutral-500 hover:text-neutral-700"
					type="button"
					@click="$emit('close')"
				>
					Thoát
				</button>
				<button
					class="button-p text-center whitespace-nowrap"
					type="button"
					:disabled="loading || !title.trim()"
					@click="confirm"
				>
					{{ loading ? 'Đang tạo...' : 'Xác nhận' }}
				</button>
			</div>
		</div>
	</div>
</template>

<style lang="scss" scoped>
.screening-title__mask {
	background: rgba(29, 40, 58, 0.45);
}

.screening-title {
	position: relative;
	width: 600px;
	max-width: 100%;
	background: #fff;
	border-radius: 16px;
	overflow: hidden;
	box-shadow: 0 0 1px rgba(12, 26, 75, 0.1),
		0 20px 24px rgba(20, 37, 63, 0.06);
}

.screening-title__body {
	padding: 32px 40px 24px;
}

.screening-title__icon {
	width: 56px;
	height: 56px;
	margin: 0 auto 16px;
	border-radius: 999px;
	display: flex;
	align-items: center;
	justify-content: center;
	background: #fef8ed;
	border: 8px solid #fef8ed;
	box-shadow: inset 0 0 0 8px #f6d692;
}

.screening-title__heading {
	text-align: center;
	font-size: 20px;
	line-height: 28px;
	font-weight: 600;
	color: #344256;
	margin-bottom: 28px;
}

.screening-title__row {
	display: flex;
	align-items: center;
	gap: 24px;
	margin-bottom: 20px;
}

.screening-title__row--top {
	align-items: flex-start;
}

.screening-title__label {
	width: 140px;
	flex-shrink: 0;
	font-size: 12px;
	line-height: 16px;
	font-weight: 600;
	letter-spacing: 0.96px;
	text-transform: uppercase;
	color: #94a3b8;
	padding-top: 14px;
}

.screening-title__row:not(.screening-title__row--top) .screening-title__label {
	padding-top: 0;
}

.screening-title__value {
	font-size: 16px;
	line-height: 24px;
	color: #344256;
}

.screening-title__input {
	width: 100%;
	height: 48px;
	padding: 0 16px;
	border-radius: 8px;
	border: 1px solid #e1e7ef;
	background: #fff;
	font-size: 16px;
	color: #344256;
	box-shadow: 0 0 1px rgba(50, 50, 71, 0.2), 0 1px 2px rgba(50, 50, 71, 0.08);
	outline: none;
}

.screening-title__error {
	display: flex;
	align-items: flex-start;
	gap: 6px;
	margin-top: 8px;
	color: #db5a41;
	font-size: 14px;
	line-height: 20px;
}

.screening-title__footer {
	display: flex;
	align-items: center;
	justify-content: flex-end;
	gap: 16px;
	padding: 20px 40px;
	background: #f8fafc;
}

.screening-title__ghost {
	padding: 10px 16px;
	font-size: 14px;
	font-weight: 600;
	color: #94a3b8;
}

.screening-title__ok {
	width: 220px;
}
</style>
